import { Button, Flex, Icon, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react'
import React from 'react'
import { RiLogoutBoxRLine, RiUserFill } from 'react-icons/ri'
import { useDispatch } from 'react-redux'
import { logoutUserAction } from '../../../modules/auth/Actions'
import { brandPalette } from "../../../constants/brandPalette";
// import { logoutUserAction } from '../../modules/auth/Actions'

const LogoutMenu = ({ compact = false }) => {
    const dispatch = useDispatch()
    return (
        <Menu closeOnSelect={false}>
            <MenuButton
                bg='transparent'
                borderRadius='full'
                as={Button}
                p='0'
                _hover={{ bg: 'transparent' }}
                _focus={{ outline: 'none', bg: 'transparent' }}
                _active={{ outline: 'none', bg: 'transparent' }}>
                <Flex
                    borderRadius='full'
                    border='2px solid'
                    borderColor={brandPalette.primary}
                    w={compact ? '44px' : '52px'}
                    h={compact ? '44px' : '42px'}
                    bg='var(--surface-muted)'
                    alignItems='center'
                    justifyContent='center'
                    boxShadow={compact ? 'sm' : undefined}
                >
                    <Icon as={RiUserFill} color={brandPalette.primary} fontSize={compact ? '22px' : '30px'} />
                </Flex>
            </MenuButton>
            <MenuList
              borderRadius="12px"
              borderColor="var(--border-subtle)"
              bg="var(--surface-raised)"
              py={2}
              zIndex={2000}
            >
                <MenuItem
                  borderRadius="8px"
                  mx={1}
                  bg="var(--surface-raised)"
                  _hover={{ bg: "var(--surface-muted)" }}
                  _focus={{ bg: "var(--surface-muted)" }}
                  onClick={() => dispatch(logoutUserAction())}
                >
                    <Flex align="center" gap={2}>
                        <Icon as={RiLogoutBoxRLine} fontSize="18px" color={brandPalette.secondary} />
                        <Text fontWeight="600" color={brandPalette.secondary}>Logout</Text>
                    </Flex>
                </MenuItem>
            </MenuList>
        </Menu >
    )
}

export default LogoutMenu